(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/chat-host-schedule-card/assets/javascripts/chat-host-schedule-card.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/chat-host-schedule-card/assets/javascripts/chat-host-schedule-card.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const Button = svs.ui.ReactButton;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;

const startBingogame = gameId => {
  svs.utils.url.navigate("".concat(svs.core.data.baseUrl, "/spela/").concat(gameId));
};
const ChatHostDateAndTime = svs.bingo_react.components.chatHostScheduleCard.ChatHostDateAndTime;
const Host = svs.bingo_react.components.bingoCard.Host;
const ChatHostScheduleCard = _ref => {
  let _ref$card = _ref.card,
    gameId = _ref$card.gameId,
    gameTitle = _ref$card.gameTitle,
    hostName = _ref$card.hostName,
    hostImage = _ref$card.hostImage,
    startTime = _ref$card.startTime,
    endTime = _ref$card.endTime;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showButton = _useState2[0],
    setShowButton = _useState2[1];

  useEffect(() => {
    const checkTime = () => {
      const fiveMinutes = 5 * 60 * 1000;
      if (startTime - Date.now() < fiveMinutes) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    checkTime();
    const intervalId = setInterval(checkTime, 1000);
    return () => clearInterval(intervalId);
  }, [startTime]);
  return React.createElement("div", {
    className: "bingo-chat-host-schedule-card"
  }, React.createElement("div", {
    className: "bingo-chat-host-schedule-card-information"
  }, React.createElement(ChatHostDateAndTime, {
    endTime: endTime,
    startTime: startTime
  }), React.createElement("div", {
    className: "bingo-chat-host-schedule-card-information__line"
  }), React.createElement("div", {
    className: "bingo-chat-host-schedule-card-information__game-info"
  }, React.createElement("h4", null, gameTitle), hostName && React.createElement(Host, {
    imgSrc: hostImage,
    name: hostName
  }))), showButton && React.createElement(Button, {
    className: "bingo-chat-host-schedule-card-information__start-btn",
    onClick: () => startBingogame(gameId),
    transparent: true
  }, "Spela"));
};
setGlobal('svs.bingo_react.components.chatHostScheduleCard.ChatHostScheduleCard', ChatHostScheduleCard);

 })(window);